// extracted by mini-css-extract-plugin
module.exports = {"large-number-input":"_3ETQqfy3","small-number-input":"hkcHjl1X"};